import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "main-content" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import HeaderNav from './components/HeaderNav.vue'
import WhatsAppButton from './components/WhatsAppButton.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import ToastNotification from './components/ToastNotification.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

const isLoading = computed(() => store.getters['ui/isLoading'])
const loadingMessage = computed(() => store.getters['ui/loadingMessage'])
const toastState = computed(() => store.getters['ui/toastState'])

const hideToast = () => {
  store.dispatch('ui/hideToast')
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderNav),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(WhatsAppButton),
    _createVNode(LoadingSpinner, {
      show: isLoading.value,
      message: loadingMessage.value
    }, null, 8, ["show", "message"]),
    _createVNode(ToastNotification, {
      show: toastState.value.show,
      type: toastState.value.type,
      title: toastState.value.title,
      message: toastState.value.message,
      onClose: hideToast
    }, null, 8, ["show", "type", "title", "message"])
  ]))
}
}

})